var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.63146 2.35096L8.63146 2.35096C8.71379 2.51562 8.64706 2.71584 8.4824 2.79816L8.48239 2.79817L4.40372 4.83751C4.40372 4.83751 4.40372 4.83751 4.40372 4.83751C3.952 5.06336 3.66667 5.52505 3.66667 6.03008V13.97C3.66667 14.475 3.952 14.9367 4.40371 15.1625L4.61934 14.7313L4.40372 15.1626L8.48239 17.2019C8.64708 17.2842 8.71377 17.4845 8.63147 17.649L8.63145 17.6491C8.54912 17.8137 8.34895 17.8805 8.18426 17.7981L4.10557 15.7588L4.10555 15.7588C3.42801 15.4201 3 14.7275 3 13.97V6.03008C3 5.27253 3.42801 4.58001 4.10557 4.24123L4.10557 4.24123L8.18425 2.20188C8.18426 2.20188 8.18426 2.20188 8.18427 2.20188C8.34894 2.11955 8.54911 2.18628 8.63146 2.35096Z",
    fill: "#6B7280",
    stroke: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.25 10.8335V10.3335H13.75H8.33333C8.14924 10.3335 8 10.1843 8 10.0002C8 9.81606 8.14924 9.66683 8.33333 9.66683H13.75H14.25V9.16683V7.91685C14.25 7.782 14.3312 7.66048 14.4557 7.6089C14.5803 7.55729 14.7237 7.58582 14.819 7.68115L15.1726 7.3276L14.819 7.68115L16.9024 9.76447C17.0325 9.89462 17.0325 10.1057 16.9024 10.2359L14.819 12.3192C14.7237 12.4146 14.5803 12.4431 14.4558 12.3915C14.3312 12.3399 14.25 12.2184 14.25 12.0835V10.8335Z",
    fill: "#6B7280",
    stroke: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.bb42334da4e754ff4f5b1f87b6d7d3e4.svg";
export { ForwardRef as ReactComponent };